module.exports = __webpack_public_path__ + "media/images/common/lp/bg-ctaBox__heading--right-59b9e5716beb7f15faf47fa8bc9e57e8.png";